<template>
    <b-container fluid class="animated fadeIn">
        <h1>Atualizar UPF/PR</h1>
        <b-card>
            <b-row>
                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-form-group label="Valor da UPF/PR vigente no sistema:" label-for="upfpr"
                        :class="'text-label ' + (!validacoes.upfpr.valid ? 'is-invalid' : '')">
                        <b-form inline style="width: 50%;" :class="!validacoes.upfpr.valid ? 'is-invalid' : ''" maxlength="10">
                            <money class="form-control" v-model="parametros.upfpr" v-bind="money"></money>
                            <b-button variant="primary" class="ml-2 fonte-branca ml-1" @click="atualizar">
                                <i :class="'fa fa-plus'"></i>
                                Atualizar
                            </b-button>
                        </b-form>
                        <div v-if="!validacoes.upfpr.valid" class="invalid-message">{{ validacoes.upfpr.message }}
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <div v-if="parametros.dataHoraAtualizacaoUpfpr != null" style="color:red">
                Última atualização em {{ parametros.dataHoraAtualizacaoUpfpr }}!
            </div>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import formatarMixins from '../../mixins/formatarMixins'
import { Money } from 'v-money'
import validacoesUtil from '../../util/validacoesUtil';

export default {
    name: 'AtualizarUpfPr',
    mixins: [formatarMixins],
    components: {
        Money
    },
    data() {
        return {
            money: {
                decimal: ',',
                thousands: '.',
                precision: 2,
                masked: false,
                prefix: 'R$ ',
            },
            parametros: {
                upfpr: 0,
                dataHoraAtualizacaoUpfpr: null
            },
            validacoes: {
                upfpr: { valid: true, message: "" },
            }
        }
    },

    watch: {
    },

    computed: {
    },

    methods: {

        atualizar() {
            this.$store.commit("setMessages", {});
            validacoesUtil.limparErroDeValidacao(this.validacoes.upfpr);
            this.validarUpfPr();
            if (!validacoesUtil.validadacaoContemErros(this.validacoes)) {
                this.salvar();
            }
        },

        validarUpfPr() {
            if(this.parametros.upfpr == null || this.parametros.upfpr <= 0) {
                validacoesUtil.adicionarErroDeValidacao(this.validacoes.upfpr, "Valor precisa ser informado!");
            }
        },

        salvar() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token
            axios.put(`${urlApi}/v1/parametros/atualizarUpfpr`, this.parametros.upfpr, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then(response => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Operação realizada com sucesso!'] });
            }).catch((error) => {
                validacoesUtil.exibirErro(error)
            })
        },

        voltar() {
            this.$router.push({ path: '/' })
        },

        obterUpfPr() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token

            axios.get(`${urlApi}/v1/parametros/obterUpfPr`, {}, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                this.parametros = response.data
            }).catch((error) => {
                validacoesUtil.exibirErro(error)
            })
        },
    },
    mounted() {
        this.obterUpfPr();
    }

}
</script>

<style scoped>
.titulo-secao {
    border-bottom: 1px solid #CECECE;
    font-weight: bold;
    font-style: italic;
    padding-left: 3px;
}
</style>